import DOMPurify from 'dompurify';
import { vMaska } from 'maska/vue';
import type { Directive, DirectiveBinding } from 'vue';

export const maskaDirectiveArguments: [string, Directive] = ['maska', vMaska];

// plaatjes uit externe bronnen vervangen door melding
DOMPurify.addHook('beforeSanitizeElements', (node) => {
  if (node instanceof Element && node.nodeName === 'IMG') {
    const src = node.getAttribute('src');
    if (!src) return;

    try {
      const url = new URL(src, document.baseURI);
      const sameDomain =
        window.location.hostname === url.hostname ||
        url.hostname.endsWith(`.${window.location.hostname}`);
      if (!sameDomain) {
        const placeholder = document.createElement('p');
        placeholder.classList.add('text-xs', 'font-mono');
        placeholder.textContent = '[afbeelding komt van een externe bron en is daarom verborgen]';
        node.parentNode?.replaceChild(placeholder, node);
      }
    } catch {
      // Ongeldige URL
    }
  }
});

export const sanitizedHtmlDirectiveArguments: [string, Directive] = [
  'sanitized-html',
  (el: HTMLElement, { value }: DirectiveBinding) => {
    el.innerHTML = DOMPurify.sanitize(value ?? '', {
      ALLOWED_TAGS: [
        'b',
        'i',
        'strong',
        'a',
        'em',
        'br',
        'ul',
        'ol',
        'li',
        'p',
        'img',
        'table',
        'thead',
        'tbody',
        'tr',
        'td',
        'th',
        'span',
      ],
      ALLOWED_ATTR: [
        'href',
        'target',
        'class',
        'src',
        'title',
        'data-variable-nummer',
        'data-variable-naam',
        'data-variable-waarde',
      ],
    });
  },
];
